import { InfoOutlined } from '@mui/icons-material';
import { Fragment, ReactNode, useState } from 'react';
import { IconButton } from '@legacy/components/mui-components';
import ReportingWidgetInfoModal from '@legacy/screens/Home/components/ReportingWidgetInfoModal';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, Stack, Box } from '@mui/material';
import { useIsMobile } from '@/hooks/useIsMobile';

interface IReportingWidgetCard {
  title: string | ReactNode;
  name: string;
  infoIconText: string | ReactNode;
  children?: ReactNode;
  toggleContent?: ReactNode;
  hasAction?: boolean;
}

export const ReportingWidgetCard = ({
  name,
  title,
  infoIconText,
  children,
  toggleContent,
  hasAction = false,
}: IReportingWidgetCard) => {
  const { t } = useTranslation('reportingWidgets');
  const [isOpen, setIsOpen] = useState(false);

  const isMobile = useIsMobile();

  return (
    <Card
      className={`Card-${title}`}
      variant="outlined"
      sx={{ height: '100%' }}
    >
      <CardHeader
        title={
          <Stack
            direction="row"
            gap={1}
            justifyContent="space-between"
            component="span"
          >
            <span>{title}</span>
            <Box
              component="span"
              display="flex"
              justifyContent={isMobile ? 'flex-start' : 'flex-end'}
            >
              {toggleContent && toggleContent}
            </Box>
          </Stack>
        }
        action={
          hasAction && (
            <>
              <Fragment key={`InfoIconButton${name}`}>
                <IconButton
                  title={t('InfoIconTooltipTitle')}
                  size="small"
                  aria-label={`info-icon-button-${name}`}
                  data-automation-id={`InfoIconButton${name}`}
                  onClick={() => setIsOpen(true)}
                >
                  <InfoOutlined />
                </IconButton>
                <ReportingWidgetInfoModal
                  id={name}
                  title={title}
                  infoMessage={infoIconText}
                  openState={isOpen}
                  setOpenState={setIsOpen}
                />
              </Fragment>
              {/*
              // DRO: Will leave the action here for a while since we are going to have this in the next iteration.
              <MuiIconButton size="small" aria-label="action">
              <MoreVert />
            </MuiIconButton> */}
            </>
          )
        }
      />
      <CardContent>{children}</CardContent>
    </Card>
  );
};
